import * as React from "react"
import { cn } from "@sarkiai/utils"

interface GlassBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export const GlassBox = ({ children, className, ...props }: GlassBoxProps) => {
  return (
    <div
      className={cn(
        "p-8 rounded-4xl border border-white/5 backdrop-blur-[10px] backdrop-saturate-[181%] bg-background/5",
        "dark:bg-background/85 dark:border-white/5 dark:backdrop-blur-[10px] dark:backdrop-saturate-[181%]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export const ToolPadGlassBox = ({ children, className, ...props }: GlassBoxProps) => {
  return (
    <div
      className={cn(
        "p-8 rounded-4xl border border-white/5 backdrop-blur-[10px] backdrop-saturate-[181%] bg-white/55",
        "dark:bg-card/85 dark:border-white/15 dark:backdrop-blur-[10px] dark:backdrop-saturate-[181%]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export const ToolPadBlackGlassBox = ({ children, className, ...props }: GlassBoxProps) => {
  return (
    <div
      className={cn(
        "text-white p-8 rounded-4xl border border-white/5 backdrop-blur-[10px] backdrop-saturate-[181%] bg-black/90",
        "dark:bg-card/85 dark:border-white/5 dark:backdrop-blur-[10px] dark:backdrop-saturate-[181%]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
